/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import * as React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import scrollTo from "gatsby-plugin-smoothscroll";

import Header from "./header";
import "normalize.css";
import "../styles/animations.css";
import "../styles/global.module.css";
import * as style from "./layout.module.css";

const Layout = ({ lang, children }) => {
  const data = useStaticQuery(graphql`
    query SiteQuery {
      site {
        siteMetadata {
          title
          intl {
            lang
            langName
            pages {
              name
              link
            }
          }
        }
      }
    }
  `);

  let navLinks = null;
  for (let i = 0; i < data.site.siteMetadata.intl.length; i++) {
    if (data.site.siteMetadata.intl[i].lang === lang) {
      navLinks = data.site.siteMetadata.intl[i].pages;
      break;
    }
  }

  let langList = [];
  data.site.siteMetadata.intl.forEach(item => {
    let langItem = {
      lang: item.lang,
      langName: item.langName,
    };
    langList.push(langItem);
  });

  React.useEffect(() => {
    const toTop = document.getElementById("layout-to-top-button");
    window.addEventListener("scroll", () => {
      let visibleStyle =
        "display: -webkit-flex;" +
        "display: -moz-flex;" +
        "display: -ms-flex;" +
        "display: -o-flex;" +
        "display: flex;";
      let hiddenStyle = "display: none;";
      if (window.scrollY <= window.innerHeight) {
        toTop.setAttribute("style", hiddenStyle);
      } else {
        toTop.setAttribute("style", visibleStyle);
      }
    });
  }, []);

  return (
    <>
      <Header
        siteTitle={data.site.siteMetadata?.title || `Title`}
        lang={lang}
        langList={langList}
        navLinks={navLinks}
      />
      <button
        id="layout-to-top-button"
        className={style.toTop}
        onClick={() => {
          scrollTo("body");
        }}
      >
        <img src={"/media/arrow_upward_white_24dp.svg"} alt="to top" />
      </button>
      <div>
        <main>{children}</main>
        <footer className={style.footer}>
          <div className={style.footerContent}>
            Copyright Michael&nbsp;Tuong-Minh&nbsp;Vo ©{new Date().getFullYear()} All&nbsp;Rights&nbsp;Reserved
          </div>
          <div className={style.footerSocial}>
            <a
              href={"https://github.com/miketvo"}
              target={"_blank"}
              rel="noreferrer"
              className={style.footerSocialItem}
            >
              <img src={"/media/footer_github.svg"} alt="Link to my GitHub" />
            </a>
            <a
              href={"https://twitter.com/ikxplicitie"}
              target={"_blank"}
              rel="noreferrer"
              className={style.footerSocialItem}
            >
              <img src={"/media/footer_twitter.svg"} alt="Link to my Twitter" />
            </a>
            <a
              href={"https://www.instagram.com/ikxplicitie/"}
              target={"_blank"}
              rel="noreferrer"
              className={style.footerSocialItem}
            >
              <img src={"/media/footer_instagram.svg"} alt="Link to my Instagram" />
            </a>
            <a
              href={"https://www.facebook.com/miketvo/"}
              target={"_blank"}
              rel="noreferrer"
              className={style.footerSocialItem}
            >
              <img src={"/media/footer_facebook.svg"} alt="Link to my Facebook" />
            </a>
          </div>
        </footer>
      </div>
    </>
  );
};

Layout.defaultProps = {
  lang: `en`,
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
